/**
 * 场馆平面图工具：多边形质心、人数热力色
 */

/** 地图上展示的区域名称：优先使用编辑时定义的 label */
export function getRegionDisplayName(region) {
  if (!region) return '';
  const label = region.label?.trim();
  if (label) return label;
  return region.id || '';
}

export function polygonCentroid(points) {
  if (!points || points.length === 0) return [0, 0];
  let sx = 0;
  let sy = 0;
  points.forEach(([x, y]) => {
    sx += x;
    sy += y;
  });
  return [sx / points.length, sy / points.length];
}

export function pointsToSvgString(points) {
  return points.map(([x, y]) => `${x},${y}`).join(' ');
}

/**
 * 根据人数在 min~max 区间映射颜色（低→高：绿→黄→红）
 */
export function countToHeatColor(count, min = 0, max = 100) {
  if (max <= min) return 'rgba(145, 202, 255, 0.55)';
  const t = Math.min(1, Math.max(0, (count - min) / (max - min)));
  const r = Math.round(76 + t * 179);
  const g = Math.round(175 - t * 120);
  const b = Math.round(80 - t * 40);
  return `rgba(${r},${g},${b},0.65)`;
}

export function readImageFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function loadImageDimensions(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = reject;
    img.src = dataUrl;
  });
}
